import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useMemo, useState } from 'react';
import { Button, Callout, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { getAccountingDetails } from '~/integrations/Accounting/accounting.utils';
import { useOpenMapContactsModal } from '~/integrations/Accounting/MapContactsModal/useOpenMapContactsModal';
import { useOpenMapServicesModal } from '~/integrations/Accounting/MapServicesModal/useOpenMapServicesModal';
import { useStoreActions } from '~/store/store-context';
import styles from './GBHMapEntitiesCallout.module.scss';
export const GetGBHMapEntitiesCalloutTID = (parentTestId)=>getTestIds({
        parentTestId,
        deprecatedTestIds: {
            GBHMapEntitiesCalloutTID: {
                Callout: (accounting)=>"map-callout-".concat(accounting),
                CalloutText: (accounting)=>"map-callout-text-".concat(accounting),
                MapContactButton: 'map-contact-callout-button',
                MapServicesButton: 'map-services-callout-button'
            }
        }
    });
export const GBHMapEntitiesCallout = (param)=>{
    let { services, clientID, refreshAgreement, accounting } = param;
    const { t: gbhTexts } = useLocaleKeys('billing.globalHub');
    const { api } = useStoreActions();
    const { GBHMapEntitiesCalloutTID } = useMemo(()=>GetGBHMapEntitiesCalloutTID(), []);
    const [contactUnintegrated, setContactUnintegrated] = useState(false);
    const policy = getAccountingDetails(accounting).policy;
    const unintegratedServices = policy.getUnintegratedServices(services, accounting);
    const hasUnintegratedServices = !!unintegratedServices.length;
    const openMapContactsModal = useOpenMapContactsModal(clientID, async ()=>{
        refreshClient(clientID);
    });
    const serviceTemplateIds = policy.getServiceTemplateIdsFromServices(unintegratedServices);
    const openMapServicesModal = useOpenMapServicesModal(serviceTemplateIds, async ()=>{
        refreshAgreement();
    });
    const refreshClient = useCallback(async (id)=>{
        if (!id) {
            setContactUnintegrated(false);
            return;
        }
        api.contact.getById(id).then((contact)=>{
            setContactUnintegrated(!(contact === null || contact === void 0 ? void 0 : contact.isIntegrated({
                accounting
            })));
        });
    }, [
        accounting
    ]);
    useEffect(()=>{
        refreshClient(clientID);
    }, [
        clientID,
        refreshClient
    ]);
    const getCalloutText = (hasUnintegratedServices, contactUnintegrated)=>{
        const accountingName = getAccountingDetails(accounting).fullName;
        if (hasUnintegratedServices && contactUnintegrated) return gbhTexts.mapEntitiesCallout.contactAndServicesNotMapped({
            accountingName
        });
        if (hasUnintegratedServices && !contactUnintegrated) return gbhTexts.mapEntitiesCallout.servicesNotMapped({
            accountingName
        });
        if (!hasUnintegratedServices && contactUnintegrated) return gbhTexts.mapEntitiesCallout.contactNotMapped({
            accountingName
        });
    };
    return contactUnintegrated || hasUnintegratedServices ? /*#__PURE__*/ _jsx(Callout, {
        testId: GBHMapEntitiesCalloutTID.Callout(accounting),
        withAction: /*#__PURE__*/ _jsxs("div", {
            className: styles.actions,
            children: [
                contactUnintegrated && /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'map_contact_from_gbh_callout'
                    },
                    testId: GBHMapEntitiesCalloutTID.MapContactButton(),
                    onClick: ()=>openMapContactsModal(accounting),
                    children: gbhTexts.mapContact()
                }),
                hasUnintegratedServices && /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'map_services_from_gbh_callout'
                    },
                    testId: GBHMapEntitiesCalloutTID.MapServicesButton(),
                    onClick: ()=>openMapServicesModal(accounting),
                    children: gbhTexts.mapServices()
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(Typography, {
            testId: GBHMapEntitiesCalloutTID.CalloutText(accounting),
            children: getCalloutText(hasUnintegratedServices, contactUnintegrated)
        })
    }) : null;
};
